import * as React from 'react';
import * as Yup from 'yup';
import {inject, observer} from 'mobx-react';
import {withRouter, RouteComponentProps} from 'react-router-dom';
import formValidatorFactory from '../../utils/formValidatorFactory';
import {Formik, FormikProps} from 'formik';
import {Auth} from '../../models/authModel';
import BaseForm, {FormValues} from './private/BaseForm';

interface ResetPasswordFormProps {
  token: string;
}

interface WithInjectedProps extends ResetPasswordFormProps, RouteComponentProps {
  auth: Auth;
}

@inject('auth')
@observer
class ResetPasswordForm extends React.Component<ResetPasswordFormProps & RouteComponentProps, {}> {
  public render() {
    const loading = this._withInjectedProps.auth.isResettingPassword;

    return (
      <Formik
        initialValues={this._initialValues}
        validate={formValidatorFactory(this._getValidationSchema)}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => <BaseForm {...props} loading={loading} />}
      />
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private get _initialValues() {
    return {password: '', passwordConfirm: ''};
  }

  private _getValidationSchema = (values: FormValues) => {
    return Yup.object().shape({
      password: Yup.string()
        .min(6, 'Password must be longer than 6 characters.')
        .required('Please enter a password.'),
      passwordConfirm: Yup.string()
        .oneOf([values.password], 'Password confirmation must match.')
        .required('Please confirm your password.')
    });
  };

  private _handleSubmit = ({password}: FormValues) => {
    this._withInjectedProps.auth.resetPassword(this.props.token, password, this._redirectToLogin);
  };

  private _redirectToLogin = () => {
    this._withInjectedProps.history.replace('/login');
  };
}

export default withRouter(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordForm/ResetPasswordForm.tsx